var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimpleArrowRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.48 14.14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.41 14.14 7.07-7.07L1.41 0 0 1.42l5.66 5.65L0 12.73z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimpleArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/simple-arrow-right.4642df0149f559b4635da1cb6dc4fe76.svg";